import React from 'react'
import { shallow, mount } from 'enzyme'
import IpAddressListForm from '../subComponents/IpAddressListForm.jsx'

jest.mock('@fortressiq/fiq-ds', () => ({
  useNotification: () => ({
    addNotification: jest.fn(),
  }),
  useModal: () => ({
    addModal: jest.fn(),
    removeModal: jest.fn(),
  }),
  useFela: () => ({
    css: jest.fn(),
    theme: {
      'default-spacer-md': '16px',
      white: '#fff',
    },
  }),
  Button: ({ children, ...props }) => (
    <button type='button' {...props}>
      {children}
    </button>
  ),
  SwitchSection: ({ label, onSwitch, ...props }) => (
    <div {...props}>
      <label>{label}</label>
      <input type='checkbox' onChange={() => onSwitch({ SWITCH_STATE: !props.checked })} />
    </div>
  ),
  Typography: { Text: ({ textToCopy }) => <span>{textToCopy}</span> },
  theme: { 'default-spacer-md': '16px', white: '#fff' },
  Badge: ({ status }) => <span>{status}</span>,
  Popconfirm: ({ children, onConfirm }) => (
    <div>
      {children}
      <button type='button' onClick={onConfirm}>
        Confirm
      </button>
    </div>
  ),
  useForm: () => ({
    register: jest.fn(),
    setError: jest.fn(),
    handleSubmit: jest.fn(fn => fn),
    formState: {
      errors: {},
    },
  }),
}))

jest.mock('axios', () => ({
  get: jest.fn(() => Promise.resolve({ data: { msg: 'Success' } })),
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('lib/Api', () => ({
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

const props = {
  handleReFetch: jest.fn(),
  removeModal: jest.fn(),
}

describe('Add IP form Component', () => {
  beforeEach(() => {
    jest.clearAllMocks()
  })

  it('should match snapshot', () => {
    const wrapper = shallow(<IpAddressListForm {...props} />)
    expect(wrapper).toMatchSnapshot()
  })

  it('Verify form submit with correct value', async () => {
    const wrapper = shallow(<IpAddressListForm {...props} />)
    wrapper.find('form').simulate('submit', {
      ip_address: {
        ip_address: '172.21.0.1',
      },
    })
    wrapper.update()

    expect(wrapper.exists()).toBe(true)
  })

  it('Verify cancel button click', async () => {
    const wrapper = shallow(<IpAddressListForm {...props} />)
    const mockEvent = { preventDefault: jest.fn() }
    wrapper.find('.cancelBtn').simulate('click', mockEvent)

    expect(wrapper.exists()).toBe(true)
    expect(mockEvent.preventDefault).toHaveBeenCalled()
  })
})
